(() => {
  const STORAGE_KEY = 'compare_show_only_differences';

  const AREA_SELECTOR = '.js-compare-area';
  const ROW_SELECTOR = '.compare-row';
  const TOOLBAR_ROW_SELECTOR = '.compare-row--toolbar';
  const TOGGLE_SELECTOR = '.js-compare-differences-toggle';

  // Filas que NUNCA ocultamos aunque sean iguales
  const ALWAYS_SHOW_KEYS = new Set([
    'compare-image',
    'compare-title',
    'compare-price',
    'compare-actions',
  ]);

  const normalize = (str) => {
    if (!str) return '';
    return String(str)
      .replace(/\u00A0/g, ' ')
      .trim()
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // sin tildes
      .replace(/[\s\-–—]+/g, '') // sin espacios/guiones (600 w == 600w)
      .replace(/[.,;:()]/g, ''); // limpia signos comunes
  };

  const getRowKey = (row) => {
    const el = row.querySelector('[data-compare-key]');
    return el ? el.getAttribute('data-compare-key') : '';
  };

  const getColValue = (col) => {
    const valueEl =
      col.querySelector('.compare-value') ||
      col.querySelector('.product-title') ||
      col.querySelector('.product-price') ||
      col;

    const text = valueEl ? (valueEl.innerText || valueEl.textContent || '') : '';
    return normalize(text);
  };

  const rowHasDifferences = (row) => {
    const cols = Array.from(row.querySelectorAll('[data-compare-key]'));
    if (cols.length <= 1) return true;

    const values = cols.map(getColValue);
    const first = values[0];
    return values.some(v => v !== first);
  };

  const apply = (area, enabled) => {
    const rows = Array.from(area.querySelectorAll(ROW_SELECTOR));

    rows.forEach((row) => {
      const key = getRowKey(row);

      if (!enabled) {
        row.hidden = false;
        return;
      }

      if (row.classList.contains('compare-row--toolbar')) {
        row.hidden = false;
        return;
      }

      if (ALWAYS_SHOW_KEYS.has(key)) {
        row.hidden = false;
        return;
      }

      const show = rowHasDifferences(row);
      row.hidden = !show;
    });
  };

  const buildToolbarRow = () => {
    const row = document.createElement('div');
    row.className = 'compare-row compare-row--toolbar flex items-center justify-start mb-4 mt-4';
    row.innerHTML = `
      <div class="compare-toolbar flex items-center justify-start w-full">
        <label class="compare-diff-toggle">
          <span class="compare-diff-toggle__text">Mostrar solo diferencias</span>
          <span class="compare-switch" aria-hidden="true">
            <input type="checkbox" class="compare-switch__input js-compare-differences-toggle">
            <span class="compare-switch__track"></span>
            <span class="compare-switch__thumb"></span>
          </span>
        </label>
      </div>
    `;
    return row;
  };

  const ensureToolbarBelowPrice = (area) => {
    let toolbarRow = area.querySelector(TOOLBAR_ROW_SELECTOR);
    if (!toolbarRow) toolbarRow = buildToolbarRow();

    const priceRow = area.querySelector('.compare-row--price');

    // Inserta SIEMPRE debajo del price (si existe)
    if (priceRow) {
      if (priceRow.nextElementSibling !== toolbarRow) {
        priceRow.insertAdjacentElement('afterend', toolbarRow);
      }
    } else {
      // fallback: al inicio del área
      if (!toolbarRow.isConnected) area.insertAdjacentElement('afterbegin', toolbarRow);
    }

    const toggle = toolbarRow.querySelector(TOGGLE_SELECTOR);
    if (toggle && !toggle.dataset.bound) {
      toggle.dataset.bound = '1';
      toggle.addEventListener('change', () => {
        localStorage.setItem(STORAGE_KEY, toggle.checked ? '1' : '0');
        const currentArea = document.querySelector(AREA_SELECTOR);
        if (currentArea) apply(currentArea, toggle.checked);
      });
    }

    const enabled = localStorage.getItem(STORAGE_KEY) === '1';
    if (toggle) toggle.checked = enabled;

    return enabled;
  };

  let raf = null;
  const refresh = () => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      raf = null;
      const area = document.querySelector(AREA_SELECTOR);
      if (!area) return;

      const enabled = ensureToolbarBelowPrice(area);
      apply(area, enabled);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    refresh();

    // Observa todo el body porque a veces el theme reemplaza COMPLETO .js-compare-area
    const obs = new MutationObserver(() => refresh());
    obs.observe(document.body, { childList: true, subtree: true });
  });
})();
